function MikkellerAndFriendsLogo() {
  return (
    <img
      height="180"
      width="140"
      src="/logos/mikkeller-and-friends-logo.png"
      className="w-full h-full object-contain px-2"
      alt="Mikkeller and Friends Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { MikkellerAndFriendsLogo };
